<template>
  <div class="header">
    <h1>信箱列表</h1>
    <div class="d-flex align-items-center col-9 justify-content-end">
      <button
        v-if="isButtonShow('setting/contact-email-update')"
        @click="$router.push('/user-management/edit-email-list')"
        class="btn btn-outline-primary col-5 add-que me-5"
      >
        編輯列表
      </button>
    </div>
  </div>
  <CRow class="my-5 fw-bold col-12 mx-auto list-title">
    <!-- <CCol xs="2" class="text-center">ID</CCol> -->
    <CCol xs="12" class="text-center text-nowrap">
      <div class="position-relative d-flex align-items-center col-4">
          <CFormInput
            class="rounded-pill pe-5"
            type="text"
            placeholder="請輸入Email"
            v-model="mailSearch"
          />
          <!-- <img
            class="position-absolute search"
            src="@/assets/icons/search.svg"
          /> -->
        </div>
    </CCol>
  </CRow>
  <div class="d-flex align-items-center" style="gap: 0 40px;flex-wrap: wrap;">
    <div v-for="item in filteredMailList"
      :key="item.name" class="mb-4 border list d-flex align-items-center justify-content-center">
      {{ item }}
    </div>
  </div>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
// import router from '@/router'
import useInfo from '@/composables/useInfo'
import MsgBox from '@/components/MsgBox.vue'
import { ref } from '@vue/reactivity'
import { formatDate } from '@/utils/format-date.js'
// import MessageBox from '@/plugins/MessageBox'
import { manualToggleLoading } from '@/plugins/LoadingSpinner'
import { useStore } from 'vuex'
import { computed } from 'vue'
export default {
  components: {
    MsgBox,
  },
  setup() {
    const { getEmailList } = useInfo()
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const mailList = ref([])
    const store = useStore()
    const mailSearch = ref('')
    const getList = async () => {
      manualToggleLoading(true)
      const res = await getEmailList()
      if (res.error) {
        manualToggleLoading(false)
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        manualToggleLoading(false)
        mailList.value = res.ret.data[0].value.split(',')
      }
    }
    getList()
    const filteredMailList = computed(() => {
      return mailList.value
        ?.filter((e) => {
          const condition = mailSearch.value
            ? e.includes(mailSearch.value)
            : true
          return condition
        })
    })
    const isButtonShow = (key)=>{
      if(store.state.userInfo.auth_data === true){
        return true
      }else{
        return Object.values(store.state.userInfo.auth_data).includes(key)
      }
    }
    const formatTimestamp = (timestamp) => {
      return formatDate(timestamp * 1000)
    }
    return {
      mailList,
      formatTimestamp,
      showMsgBox,
      errorMsg,
      errorCode,
      isButtonShow,
      mailSearch,
      filteredMailList
    }
  },
}
</script>
<style lang="scss" scoped>
.title-wrapper {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1%;
  box-shadow: rgb(69 69 69 / 15%) 0px 1px 4px 0px;
  margin: 0 0 10px 0;
  img {
    width: 100px;
  }
}
.header {
  padding: 40px 0px;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
}
h3 {
  font-size: 22px;
  margin: 0 20px 0;
}
.que-btn {
  height: 150px;
  box-shadow: 0 1px 4px 0 rgb(69 69 69 / 20%), 0 1px 2px 0 rgb(69 69 69 / 10%);
  border-radius: 4px;
}
.list-title {
  font-size: 14px;
}
.list {
  height: 48px;
  border-radius: 20px;
  width: calc( 50% - 20px );
}
.state {
  border-radius: 4px;
  color: #fff;
  width: 64px;
  height: 24px;
  font-size: 12px;
  display: flex;
  align-items: center;
  margin: auto;
  justify-content: center;
}
.result {
  font-size: 12px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  white-space: nowrap;
}
.list-btn {
  font-size: 12px;
  display: flex;
  align-items: center;
  width: 64px;
  height: 24px;
  img {
    width: 16px;
    margin-left: 5px;
  }
}
.list-tips {
  cursor: no-drop;
}
.add-que {
  background: #d1e5ef;
  border-radius: 20px;
  height: 50px;
}
.filter {
  margin-top: 50px;
}

.search {
  right: 16px;
}
</style>
